<template>
  <div class="container overview">
      <div class="container h-100 mt-5">
        <div class="container intro h-100">
          <div class="row h-100 justify-content-center align-items-center">
            <div class="col-md-6">
              <h3>Overview Page</h3>
              <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi consequuntur iure, consequatur facilis minima laudantium quo quisquam magnam est officia.</p>
            </div>
             <div class="col-md-6">
              <img src="/img/svg/admin/overview.svg" class="img-fluid">
            </div>
          </div>
        </div>
      </div>    
  </div>
</template>

<script>
export default {
  name: "Overview"
}
</script>

<style lang="scss" scoped>

</style>